/**
 * Un ToggleButton pour basculer des états avec son label, pour une utilisation dans des formulaires.
 * @param onClick - Fonction de rappel à exécuter lors du clic sur le bouton.
 * @returns Le composant ToggleButtonField.
 */

import React from 'react';
import ToggleButton from '../ToggleButton/ToggleButton';
import '../../styles/global.css';

interface ToggleButtonFieldProps {
	label: string;
	isOn: boolean;
	onChange?: (value: boolean) => void;
	invert?: boolean;
	size?: 'sm' | 'md' | 'lg';
	loading?: boolean;
	readonly?: boolean;
}

const ToggleButtonField: React.FC<ToggleButtonFieldProps> = ({
	label,
	isOn,
	onChange,
	invert = false,
	size = 'md',
	loading,
	readonly = false,
}) => {
	// Génération d'un identifiant unique pour le switch
	const switchId = `switch-${label.replace(/\s+/g, '-')}`;

	// Rendu du composant
	return (
		<div className="flex items-center space-x-3">
			{invert && (
				<label
					htmlFor={switchId}
					className={`block text-sm font-medium text-gray-700`}
				>
					{label}
				</label>
			)}
			<ToggleButton
				id={switchId}
				isOn={isOn}
				onChange={onChange}
				size={size}
				loading={loading}
				readonly={readonly}
			/>
			{!invert && (
				<label
					htmlFor={switchId}
					className={`block text-sm font-medium text-gray-700`}
				>
					{label}
				</label>
			)}
		</div>
	);
};

export default ToggleButtonField;
